import styled, { css, themeGet, device } from '@styled'
import { Col } from '@ui/wrapper'

export const PageHeaderWrap = styled.section`
  text-align: center;
  isolation: isolate;
  overflow: hidden;
`

export const StyledBG = styled.div`
  position: absolute;
  inset: 0;
  z-index: -1;
  & > div {
    height: 100%;
    width: 100%;
  }
`

export const StyledCol = styled(Col)`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 325px;
  ${device.small} {
    height: 350px;
  }
  ${device.medium} {
    justify-content: left;
    height: 375px;
  }
  ${device.large} {
    justify-content: left;
    height: 400px;
  }
  position: relative;
`

export const StyledTitle = styled.h1`
  margin-left: 10%;
  margin-right: 10%;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 3px;
  padding-left: 20px;
  padding-right: 20px;
  background: rgba(255, 255, 255, 0.7);
  span {
    color: ${themeGet('colors.secondary')};
  }
  position: relative;
  font-weight: lighter;
  ${() => css`
    color: ${'#00408a'};
  `}
`

export const StyledDesc = styled.h5`
  color: #fff;
  font-weight: 400;
`
